import React, {useState, useEffect} from 'react';
import MaterialTable from 'material-table';
import { forwardRef } from 'react';
import AddBox from '@mui/icons-material/AddBox';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import Check from '@mui/icons-material/Check';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Clear from '@mui/icons-material/Clear';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import Edit from '@mui/icons-material/Edit';
import FilterList from '@mui/icons-material/FilterList';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
import Remove from '@mui/icons-material/Remove';
import SaveAlt from '@mui/icons-material/SaveAlt';
import Search from '@mui/icons-material/Search';
import ViewColumn from '@mui/icons-material/ViewColumn';
import InfoIcon from '@mui/icons-material/Info';
import {
  IconButton,
  Paper,
  Button,
  Tooltip,
  Grid,
  CircularProgress
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import SaveIcon from '@mui/icons-material/Save';
import Title from '../../../components/Title';
import useStylesMain from '../../../useStyles';
import socket from '../../../services/socket';
import api from '../../../services/api'

export default function EditProduct(props) {
    const [isLoading,setIsLoading] = useState(false);
    const classesMain = useStylesMain()
    const [store_id,setStore_id] = useState(props.store)
    const [state, setState] = React.useState({
        columns: [
                { title: 'Produto', field: 'product' },
            ],
            data: []
    })
    const newLocalization = {
        error: "Dados não foram encontrados!",
        grouping: {
        groupedBy: "Agrupar por:",
        placeholder: "Drag headers here to group by"
        },
        pagination: {
            labelRowsSelect: 'linhas',
            labelDisplayedRows: '{count} de {from}-{to}',
            firstTooltip: 'Primeira página',
            previousTooltip: 'Página anterior',
            nextTooltip: 'Próxima página',
            lastTooltip: 'Última página'
        },
        toolbar: {
            addRemoveColumns: 'Adicionar ou deletar colunas',
            nRowsSelected: '{0} linha(s) selecionada(s)',
            showColumnsTitle: 'Ver colunas',
            showColumnsAriaLabel: 'Ver colunas',
            exportTitle: 'Exportar',
            exportAriaLabel: 'Exportar',
            exportName: 'Exportar em CSV',
            searchTooltip: 'Procurar',
            searchPlaceholder: 'Procurar'
        },
        header: {
            actions: 'Ações'
        },
        body: {
            filterRow: {
                filterTooltip: 'Filtrar'
            },
            editRow: {
                saveTooltip: "Salvar",
                cancelTooltip: "Cancelar",
                deleteText: "Tem certeza que deseja deletar esta linha?"
            },
            addTooltip: "Adicionar",
            deleteTooltip: "Deletar",
            editTooltip: "Editar",
            bulkEditTooltip: "Editar tudo",
            bulkEditApprove: "Salvar todas modificações",
            bulkEditCancel: "Ignorar todas trocas",
            emptyDataSourceMessage: 'Nenhum registro para exibir'
        },
    }

    useEffect( () => {    
        setIsLoading(true)
        setStore_id(props.store)
        function askProductInfo(){
          socket.emit('/vezo/addInfo/askProductInfo',{ 
                          'store_id': store_id,
                        }
                        ,(data)=>{console.log(data);})
        }
        async function loadProductInfo(){
            askProductInfo()
            socket.on('/vezo/addInfo/updateProductInfo/'+store_id,()=>{
                // When the server sends a updatePaperInfo, it asks for newer intel
                askProductInfo();
            })
            socket.on('/vezo/addInfo/ProductInfo/'+store_id,(data)=>{
                setState((prevState) => {
                    return { ...prevState, data };
                });
                setIsLoading(false)
            });
            return () => socket.disconnect();
        }
        loadProductInfo(); 
      },[props,store_id]);

    async function sendDataHttp(){
        try{
            setIsLoading(true)
            let data = { 
                'data': state.data
            }
            // const token = await sessionStorage.getItem('token')
            await api.post('/vezo/editProducts/sendDataProduct/'+store_id,data);
            setIsLoading(false)
            alert("Atualizado com sucesso!")
        }
        catch(err){
            console.log(err)
            setIsLoading(false)
            alert("Erro de atualização, recarregue a página!")
        }
    }

    const tableIcons = {
        Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
        Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
        Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
        Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
        DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
        Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
        Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
        Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
        FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
        LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
        NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
        PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
        ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
        Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
        SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
        ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
        ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
    };

    return (
        <Paper className={classesMain.paper}>
            <Grid container spacing={3}  justifyContent={"center"} direction="row">
                <Grid item xs={12} md={1} lg={1}>
                <Tooltip title="Editar, adicionar ou desabilitar da loja! Sempre salve após as alterações!">
                    <IconButton aria-label="Selecionar" size="large">
                    <InfoIcon />
                    </IconButton>
                </Tooltip> 
                </Grid>
                <Grid item xs={12} md={10} lg={8}>
                <Title> <HelpOutlineIcon />Produtos</Title>
                </Grid>
                <Grid item xs={12} md={1} lg={3}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<SaveIcon />}
                        onClick={sendDataHttp}
                    >
                        Salvar
                    </Button>
                </Grid>
            </Grid>
            <Grid item xs={12} md={12} lg={12}> 
                {isLoading ?
                    <div style={{paddingTop:'10px'}}>
                        <CircularProgress size={64} />
                    </div>
                    :
                    <MaterialTable
                    icons={tableIcons}
                    title="Produtos"
                    localization={newLocalization}
                    columns={state.columns}
                    data={state.data}
                    editable={{
                        onRowAdd: (newData) =>
                        new Promise((resolve) => {
                            setTimeout(() => {
                            resolve();
                            setState((prevState) => {
                                const data = [...prevState.data];
                                data.push(newData);
                                return { ...prevState, data };
                            });
                            }, 1);
                        }),
                        onRowUpdate: (newData, oldData) =>
                        new Promise((resolve) => {
                            setTimeout(() => {
                            resolve();
                            if (oldData) {
                                setState((prevState) => {
                                const data = [...prevState.data];
                                data[data.indexOf(oldData)] = newData;
                                return { ...prevState, data };
                                });
                            }
                            }, 1);
                        }),
                        onRowDelete: (oldData) =>
                        new Promise((resolve) => {
                            setTimeout(() => {
                            resolve();
                            setState((prevState) => {
                                const data = [...prevState.data];
                                data.splice(data.indexOf(oldData), 1);
                                return { ...prevState, data };
                            });
                            }, 1);
                        }),
                    }}
                    />
                }
            </Grid>
        </Paper >
    );
    }